<!-- <div class="panel__content no-padding panel-body">
    <div class="loader-container">
        <mat-spinner *ngIf="_isLoading" class="loading-spinner"></mat-spinner>
    </div>
    <div *ngIf="!_isLoading && EquipmentShovelData?.length > 0">
        <div class="mb-2">
            <i *ngIf="!_isLoading && !showColumnPanel" class="material-icons"
                (click)="showColumnPanel = !showColumnPanel"
                style="cursor: pointer; transform: scale(1) rotate(90deg); color: #428bca;">
                forward
            </i>
            <i *ngIf="!_isLoading && showColumnPanel" class="material-icons"
                (click)="showColumnPanel = !showColumnPanel"
                style="cursor: pointer; transform: scale(1) rotate(270deg); color: #428bca;">
                forward
            </i>

        </div>
        <div class="column-panel" *ngIf="showColumnPanel">
            <button mat-icon-button (click)="openColumnPopup()" style="float: right; margin-bottom: 10px;">
                <mat-icon class="warn">sort</mat-icon></button>
            <span style="font-weight: bold; margin-right: 10px;">Show / Hide Components:</span>
            <mat-checkbox class="column-item" *ngFor="let col of DashBoardShovelShowHideColumnsName"
                [(ngModel)]="col.Checked" (change)="onColumnChange(col)">
                {{ col.CompartType }}
            </mat-checkbox>
        </div>
        <table class="table table--striped table--full-width">
            <thead class="sticky-row-1">
                <tr>
                    <th>Customer</th>
                    <th>Jobsite</th>
                    <th>Unit</th>
                    <th>Model</th>
                    <th *ngFor="let col of visibleComponentColumns">
                        {{ col.title }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let equipment of EquipmentShovelData; trackBy: trackByEquipment">
                    <ng-container *ngIf="equipment.VisibleComponents?.length">
                        <ng-container
                            *ngFor="let component of equipment.VisibleComponents; let first = first; trackBy: trackByComponent">
                            <tr style="cursor: pointer;">
                                <td *ngIf="first" [attr.rowspan]="equipment.VisibleComponents.length"
                                    class="td-width no-wrap" (click)="navigateToEquipment(equipment.EquipmentId_Auto)">
                                    {{equipment.Customer}}
                                </td>
                                <td *ngIf="first" [attr.rowspan]="equipment.VisibleComponents.length"
                                    class="td-width no-wrap" (click)="navigateToEquipment(equipment.EquipmentId_Auto)">
                                    {{equipment.Jobsite}}
                                </td>
                                <td *ngIf="first" [attr.rowspan]="equipment.VisibleComponents.length"
                                    class="td-width no-wrap" (click)="navigateToEquipment(equipment.EquipmentId_Auto)">
                                    {{equipment.UnitNo}}
                                </td>
                                <td *ngIf="first" [attr.rowspan]="equipment.VisibleComponents.length"
                                    class="td-width no-wrap" (click)="navigateToEquipment(equipment.EquipmentId_Auto)">
                                    {{equipment.ModelDesc}}
                                </td>
                                <ng-container *ngFor="let col of visibleComponentColumns; trackBy: trackByColumn">
                                    <td class="no-wrap" (click)="openShovelPopup(equipment.EquipmentId_Auto)" [ngStyle]="col.id === 'Status' ? {
                                    'background-color': component.DisplayValues.StatusColor,
                                    'color': getTextColor(component.DisplayValues.StatusColor),
                                    'font-weight': '600',
                                    'text-align': 'center'
                                        } : null">
                                        {{ component.DisplayValues[col.id] }}
                                    </td>
                                </ng-container>
                            </tr>
                        </ng-container>
                        <tr class="equipment-separator">
                            <td colspan="29"></td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
    <div *ngIf="!_isLoading && EquipmentShovelData?.length === 0" class="no-data-message">
        {{'No data available' | translate | async}}
    </div>
</div> -->
<div class="panel__content no-padding panel-body">

    <div class="loader-container">
        <mat-spinner *ngIf="_isLoading" class="loading-spinner">
        </mat-spinner>
    </div>
    <div *ngIf=" !_isLoading && EquipmentShovelData?.length > 0">
        <div class="mb-2">
            <!-- Show panel -->
            <i *ngIf="!_isLoading && !showColumnPanel" class="material-icons arrow-90"
                (click)="showColumnPanel = !showColumnPanel">
                forward
            </i>
            <!-- Hide panel -->
            <i *ngIf="!_isLoading &&showColumnPanel" class="material-icons arrow-270"
                (click)="showColumnPanel = !showColumnPanel">
                forward
            </i>
        </div>
        <div class="column-panel" *ngIf="showColumnPanel">
            <button class="button-sort" mat-icon-button (click)="openColumnPopup()">
                <mat-icon class="warn"> sort</mat-icon>
            </button>
            <span class="showHide-component">
                Show / Hide Components:
            </span>
            <mat-checkbox class="column-item" *ngFor="
                    let col of DashBoardShovelShowHideColumnsName
                " [(ngModel)]="col.Checked" (change)="onColumnChange(col)">
                {{ col.CompartType }}
            </mat-checkbox>
        </div>
        <div class="shovel-top-scrollbar" #topScroll (scroll)="onTopScroll()">
            <div [style.width.px]="tableScrollWidth"></div>
        </div>
        <div class="shovel-table-wrapper" #tableWrapper (scroll)="onTableScroll()">
            <table #shovelTable class="table table--striped table--full-width shovel-table">
                <thead>
                    <tr class="group-header">
                        <!-- Fixed columns -->
                        <th rowspan="2" class="equipment-header sticky-col sticky-col-1"> Customer </th>
                        <th rowspan="2" class="equipment-header sticky-col sticky-col-2"> Jobsite </th>
                        <th rowspan="2" class="equipment-header sticky-col sticky-col-3"> Unit </th>
                        <th rowspan="2" class="equipment-header sticky-col sticky-col-4"> Model</th>
                        <!-- Dynamic GROUPS -->
                        <ng-container *ngFor="let group of columnGroups;trackBy: trackByGroup">
                            <th *ngIf="isGroupVisible(group)" [attr.colspan]="getGroupColspan(group)"
                                class="group-title group-separator"> {{ group.title }}</th>
                        </ng-container>
                    </tr>
                    <tr class="column-header">
                        <ng-container *ngFor=" let group of columnGroups; trackBy: trackByGroup ">
                            <ng-container *ngFor=" let col of getVisibleColumnsForGroup(group);trackBy: trackByColumn ">
                                <th [class.group-end]="isLastVisibleColumnOfGroup(col)"
                                    [class.notes-column]="col.id === 'Notes'"
                                    [class.sticky-component-col]="isStickyColumn(col)"
                                    [style.left.px]="isStickyColumn(col) ? getStickyLeft(col) : null"
                                    [style.width.px]="isStickyColumn(col) ? getColumnWidth(col) : null"
                                    [style.min-width.px]="isStickyColumn(col) ? getColumnWidth(col) : null"
                                    [style.max-width.px]="isStickyColumn(col) ? getColumnWidth(col) : null"
                                    class="column-header-cell">
                                    {{ getColumnTitle(col) }}
                                </th>
                            </ng-container>
                        </ng-container>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor=" let equipment of EquipmentShovelData;trackBy: trackByEquipment">
                        <ng-container *ngIf="equipment.VisibleComponents?.length">
                            <ng-container
                                *ngFor="let component of equipment.VisibleComponents;let first = first;trackBy: trackByComponent ">
                                <tr class="component-row">
                                    <!-- Fixed Equipment Columns -->
                                    <td *ngIf="first" [attr.rowspan]="equipment.VisibleComponents.length"
                                        class="equipment-cell sticky-col sticky-col-1 no-wrap"
                                        (click)="navigateToEquipment(equipment.EquipmentId_Auto)">
                                        {{ equipment.Customer }}
                                    </td>

                                    <td *ngIf="first" [attr.rowspan]="equipment.VisibleComponents.length"
                                        class="equipment-cell sticky-col sticky-col-2 no-wrap"
                                        (click)="navigateToEquipment(equipment.EquipmentId_Auto)">
                                        {{ equipment.Jobsite }}
                                    </td>

                                    <td *ngIf="first" [attr.rowspan]="equipment.VisibleComponents.length"
                                        class="equipment-cell sticky-col sticky-col-3 no-wrap"
                                        (click)="navigateToEquipment(equipment.EquipmentId_Auto)">
                                        {{ equipment.UnitNo }}
                                    </td>

                                    <td *ngIf="first" [attr.rowspan]="equipment.VisibleComponents.length"
                                        class="equipment-cell sticky-col sticky-col-4 no-wrap"
                                        (click)="navigateToEquipment(equipment.EquipmentId_Auto)">
                                        {{ equipment.ModelDesc }}
                                    </td>
                                    <!-- Dynamic Columns -->
                                    <ng-container *ngFor="let group of columnGroups; trackBy: trackByGroup">
                                        <ng-container
                                            *ngFor="let col of getVisibleColumnsForGroup(group);trackBy: trackByColumn        ">
                                            <td class="no-wrap" [class.group-end]="isLastVisibleColumnOfGroup(col)"
                                                [class.notes-column]="col.id === 'Notes'" [class.sticky-component-col]="
                                                isStickyColumn(col)"
                                                [style.left.px]="isStickyColumn(col)? getStickyLeft(col): null"
                                                [style.width.px]="
                                                isStickyColumn(col)? getColumnWidth(col): null" [style.min-width.px]="isStickyColumn(col)? getColumnWidth(col)
                                                    : null"
                                                [style.max-width.px]="isStickyColumn(col) ? getColumnWidth(col): null "
                                                [title]="
                                                col.id === 'Notes' ? component.DisplayValues[col.id]: '' " (click)="openShovelPopup( equipment.EquipmentId_Auto)
                                                " [ngStyle]="  col.id === 'Status' ? {  'background-color': component.DisplayValues.StatusColor,  'color':
                                                        getTextColor(  component.DisplayValues.StatusColor), 'font-weight': '600', 'text-align': 'center'
                                                }
                                                : null
                                        ">
                                                {{ component.DisplayValues[col.id] }}
                                            </td>
                                        </ng-container>
                                    </ng-container>
                                </tr>
                            </ng-container>
                            <!-- Equipment separator -->
                            <tr class="equipment-separator">
                                <td [attr.colspan]="visibleComponentColumns.length + 4">
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
    <div *ngIf=" !_isLoading && EquipmentShovelData?.length === 0 && this._currentSearchItemSelection.length != 9"
        class="no-data-message">
        {{ 'No data available' | translate | async }}
    </div>
</div>